<div class="integrations-hub">
  <header class="hub-header">
    <div>
      <h1>Integrations</h1>
      <p class="subtitle">
        Connect SigmaT with project management, scheduling, and design tools used on your highway and construction projects.
      </p>
    </div>
  </header>

  <div class="filters">
    <button
      type="button"
      class="filter-chip"
      [class.active]="categoryFilter === 'all'"
      (click)="setCategory('all')"
    >
      All
    </button>
    <button
      type="button"
      class="filter-chip"
      *ngFor="let cat of categories"
      [class.active]="categoryFilter === cat.id"
      (click)="setCategory(cat.id)"
    >
      {{ cat.label }}
    </button>
  </div>

  <div class="cards" *ngIf="!loadingStatus || filteredCards.length">
    <article
      class="integration-card"
      *ngFor="let card of filteredCards"
      (click)="openSetup(card)"
      (keydown.enter)="openSetup(card)"
      tabindex="0"
      role="button"
    >
      <div class="card-top">
        <div class="icon" [style.background]="card.accent">{{ card.iconLabel }}</div>
        <span class="badge" [ngClass]="statusBadgeClass(card)">{{ statusBadgeText(card) }}</span>
      </div>
      <h2>{{ card.name }}</h2>
      <p class="vendor">{{ card.vendor }} · {{ categoryLabel(card.category) }}</p>
      <p class="desc">{{ card.description }}</p>
      <ul class="features">
        <li *ngFor="let f of card.features">{{ f }}</li>
      </ul>
      <div class="card-footer">
        <span class="setup-link">Configure →</span>
      </div>
    </article>
  </div>

  <p class="loading-hint" *ngIf="loadingStatus">Checking connection status…</p>
</div>
